import { render, staticRenderFns } from "./CustomPagesList.vue?vue&type=template&id=7674a4eb&scoped=true&"
import script from "./CustomPagesList.vue?vue&type=script&lang=js&"
export * from "./CustomPagesList.vue?vue&type=script&lang=js&"
import style0 from "./CustomPagesList.vue?vue&type=style&index=0&id=7674a4eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674a4eb",
  null
  
)

export default component.exports